import { Search } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { Restricted } from '@procureai/permissions-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Textfield } from '~/components/Textfield/Textfield';
import { RouteId } from '~/routes';

import contractImage from './contract.png';
import { OrderImage, SupplierImage, ContractImage, ContentWrap, Content } from './Home.styled';
import orderImage from './order.png';
import supplierImage from './supplier.png';

export const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ContentWrap data-testid="page-home">
      <Restricted needs={{ permission: Permission.SearchView }}>
        <Content>
          <ContractImage src={contractImage} alt="Contract" />
          <OrderImage src={orderImage} alt="Order" />
          <SupplierImage src={supplierImage} alt="Supplier" />
          <Textfield
            value=""
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            placeholder={t('Home.inputPlaceholder')}
            onClick={() => {
              navigate(RouteId.search);
            }}
            data-intercom-target="Home Input"
            InputProps={{
              notched: false,
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <Search fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Content>
      </Restricted>
    </ContentWrap>
  );
};
